module.exports = __webpack_public_path__ + "img/img (6).d76ee584.jpg";